import http from 'utils/http';
import { MetaApiResponse } from 'utils/types/CommonApiResponse';
import {
  getTelephonyEndpointAssignmentsUrl,
  getTelephonyEndpointAvailableNumbersUrl,
  getTelephonyEndpointGatewayStateUrl,
  getTelephonyEndpointPurchaseUrl,
  getTelephonyEndpointUrl,
  getTelephonyEndpointsUrl
} from './apiUrls';
import { AssignRolesPayload, CreateSipEndpointPayload, PurchaseEndpointPayload, TelephonyEndpoint } from './types';

export function getTelephonyEndpoints(
  params?: Record<string, unknown>
): Promise<{ data: TelephonyEndpoint[]; meta: MetaApiResponse }> {
  return http.get(getTelephonyEndpointsUrl(), params);
}

export function getTelephonyEndpoint(id: number | string): Promise<TelephonyEndpoint> {
  return http.get(getTelephonyEndpointUrl(id));
}

export function createTelephonyEndpoint(payload: CreateSipEndpointPayload): Promise<TelephonyEndpoint> {
  return http.post(getTelephonyEndpointsUrl(), payload);
}

export function updateTelephonyEndpoint(
  id: number | string,
  payload: { telephony_endpoint: Record<string, unknown> }
): Promise<TelephonyEndpoint> {
  return http.patch(getTelephonyEndpointUrl(id), payload);
}

export function deleteTelephonyEndpoint(id: number | string): Promise<unknown> {
  return http.delete(getTelephonyEndpointUrl(id), undefined, { skipConfirm: true });
}

export function getAvailableEndpointNumbers(params: Record<string, unknown>): Promise<{ data: string[] }> {
  return http.get(getTelephonyEndpointAvailableNumbersUrl(), params);
}

export function purchaseTelephonyEndpoint(payload: PurchaseEndpointPayload): Promise<TelephonyEndpoint> {
  return http.post(getTelephonyEndpointPurchaseUrl(), payload);
}

export function assignTelephonyEndpointRoles(
  id: number | string,
  payload: AssignRolesPayload
): Promise<TelephonyEndpoint> {
  return http.put(getTelephonyEndpointAssignmentsUrl(id), payload);
}

export function getTelephonyEndpointGatewayState(id: number | string): Promise<{
  data: {
    registered?: boolean;
    state?: string;
    gateway_id?: string;
    endpoint?: TelephonyEndpoint;
  };
}> {
  return http.get(getTelephonyEndpointGatewayStateUrl(id));
}
